import React from "react";
import { Modal } from "react-bootstrap";

class RentalInternalRefModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      refInterne: props.rental?.ref_interne || "",
      isSubmitting: false,
    };
  }

  componentDidUpdate(prevProps) {
    // Réinitialiser le state quand la modal s'ouvre
    if (!prevProps.show && this.props.show && this.props.rental) {
      this.setState({
        refInterne: this.props.rental.ref_interne || "",
        isSubmitting: false,
      });
    }
  }

  handleRefInterneChange = (e) => {
    this.setState({ refInterne: e.target.value });
  };

  handleSubmit = () => {
    const { refInterne } = this.state;
    const { onConfirm } = this.props;

    if (!refInterne || refInterne.trim() === "") {
      return;
    }

    this.setState({ isSubmitting: true });
    onConfirm(refInterne.trim());
  };

  render() {
    const { show, rental, isLoading, onClose } = this.props;
    const { refInterne, isSubmitting } = this.state;

    if (!show || !rental) return null;

    const productName = rental.product?.designation || rental.product_name || "Produit";
    const establishmentName = rental.establishment?.name || "Etablissement";
    const loading = isLoading || isSubmitting;
    const isFormValid = refInterne && refInterne.trim() !== "";

    return (
      <Modal
        show={show}
        onHide={onClose}
        backdrop={loading ? "static" : true}
        keyboard={!loading}
        centered
        size="md"
        className="rental-internal-ref-modal"
        dialogClassName="modal-dialog-rounded"
      >
        <Modal.Header className="rental-modal-header-gradient">
          <Modal.Title className="rental-modal-title">
            <i className="fas fa-tag"></i>
            Modifier la reference interne
          </Modal.Title>
          {!loading && (
            <button
              type="button"
              onClick={onClose}
              className="rental-validation-modal-close-btn"
            >
              <span>&times;</span>
            </button>
          )}
        </Modal.Header>

        <Modal.Body className="rental-modal-body">
          <div className="rental-modal-body-inner">
            <div className="rental-modal-product-section">
              <div className="rental-modal-product-label">
                Location :
              </div>
              <div className="rental-modal-product-name">{productName}</div>
              <div className="rental-modal-date-info">
                <strong>{establishmentName}</strong>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12 mb-3">
              <label className="rental-modal-form-label rental-modal-form-label-required">
                Reference interne
              </label>
              <input
                type="text"
                className="rental-modal-form-input"
                value={refInterne}
                onChange={this.handleRefInterneChange}
                placeholder="Saisir la reference interne"
                disabled={loading}
                autoFocus
              />
              <small className="text-muted">
                Cette reference sera synchronisee avec l'equipement associe.
              </small>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="rental-modal-footer">
          <button
            onClick={onClose}
            disabled={loading}
            className="rental-modal-btn-cancel"
          >
            Annuler
          </button>
          <button
            onClick={this.handleSubmit}
            disabled={loading || !isFormValid}
            className={`rental-modal-btn-primary ${
              loading || !isFormValid
                ? "rental-modal-btn-primary-disabled"
                : "rental-modal-btn-primary-enabled"
            }`}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span>Enregistrement...</span>
              </>
            ) : (
              <>Enregistrer</>
            )}
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default RentalInternalRefModal;
